import React, { useState } from "react";
import { Button, Col, Row, Form } from "react-bootstrap";
import jsDig from "utils/jsDig";
import { v4 as uuidv4 } from "uuid";
import CustomFormCheck from "utils/CustomFormCheck";
import NumberDropdown from "utils/NumberDropdown";

export default function Permissions(props) {
  const [isEnabled, setIsEnabled] = useState(
    props.client_account.custom_website_permissions_enabled ? props.client_account.custom_website_permissions_enabled : false
  );
  const [customPermissions, setCustomPermissions] = useState(
    jsDig(["client_account", "custom_website_permissions"], props)
      ? jsDig(["client_account", "custom_website_permissions"], props)
      : [{ id: uuidv4(), website: "", permission: 1 }]
  );
  const permissionHandler = (items) => {
    if (!isEnabled) {
      return;
    }
    setCustomPermissions(items);
  };
  return (
    <div>
      <Row className="mx-4 pt-3 trim-margin" style={{ backgroundColor: "#EEEEEE" }}>
        <Col className="permission-column">
          <div className="pb-4">
            <h3 className="section-header px-3">Website Permissions</h3>
          </div>
          <Row className="pb-4">
            <Col xs={12} md={6}>
              <p className="primary px-3">
                Communicate website permissions from the client to the {props.organization.name} team below. Select your global settings to dictate the overall
                permissions for the website and then use the custom permissions fields if necessary to dictate anything that might vary from your global. For
                eample, if a client wants no changes made to the site but they are okay with changes to content specifically, set the Global permission to a
                1, and then add 'Content' in the custom fields at a 2 or 3.
              </p>
            </Col>
            {/* <Col></Col> */}
          </Row>

          <div className="table-responsive mb-0">
            <div className="permission">
              <Row style={{ paddingBottom: "45px", paddingRight: "10px" }} className="ml-0 trim-margin cp trim-padding permission-table">
                <Col md={3} xs={4} className="global-permissions">
                  <h4 className="section-header mb-4 px-3">Global permissions</h4>

                  <Row className="justify-content-center">
                    <Col className="col-1">
                      <Form.Check
                        name="global_website_permissions"
                        custom
                        label=""
                        type="radio"
                        id="globalperm4"
                        value="4"
                        defaultChecked={props.client_account.global_website_permissions == "4" ? true : false}
                      />
                    </Col>
                    <Col className="col-1">
                      {" "}
                      <span className="button-4">4</span>
                    </Col>
                    <Col className="col-8">
                      <h6 className="nunito-regular mb-0 primary">Free to make changes, no notification necessary</h6>
                    </Col>
                  </Row>
                  <Row className="justify-content-center" style={{ marginBottom: "14px", paddingTop: "14px" }}>
                    <Col className="col-1">
                      <Form.Check
                        name="global_website_permissions"
                        custom
                        label=""
                        type="radio"
                        id="globalperm3"
                        value="3"
                        defaultChecked={props.client_account.global_website_permissions == "3" ? true : false}
                      />
                    </Col>
                    <Col className="col-1">
                      {" "}
                      <span className="button-3">3</span>
                    </Col>
                    <Col className="col-8">
                      <h6 className="nunito-regular mb-0 primary"> Free to make changes with follow-up email summary </h6>
                    </Col>
                  </Row>
                  <Row className="justify-content-center" style={{ marginBottom: "14px", paddingTop: "14px" }}>
                    <Col className="col-1">
                      <Form.Check
                        name="global_website_permissions"
                        custom
                        label=""
                        type="radio"
                        id="globalperm2"
                        value="2"
                        defaultChecked={props.client_account.global_website_permissions == "2" ? true : false}
                      />
                    </Col>
                    <Col className="col-1">
                      {" "}
                      <span className="button-2">2</span>
                    </Col>
                    <Col className="col-8">
                      <h6 className="nunito-regular mb-0 primary">All changes require prior approval</h6>
                    </Col>
                  </Row>
                  <Row className="justify-content-center" style={{ marginBottom: "14px", paddingTop: "14px" }}>
                    <Col className="col-1">
                      <Form.Check
                        name="global_website_permissions"
                        defaultChecked={props.client_account.global_website_permissions == "1" ? true : false}
                        custom
                        label=""
                        type="radio"
                        id="globalperm1"
                        value="1"
                      />
                    </Col>
                    <Col className="col-1">
                      {" "}
                      <span className="button-1">1</span>
                    </Col>
                    <Col className="col-8">
                      <h6 className="nunito-regular mb-0 primary">
                        {" "}
                        No changes allowed, or exceptions only{" "}
                      </h6>
                    </Col>
                  </Row>
                </Col>
                <Col md={6} xs={12} className="custom-permission">
                  <h4 className="section-header mb-3">Custom permissions/exceptions</h4>
                  <Row className=" mb-3 align-items-center" style={{ marginLeft: "30px" }}>
                    <CustomFormCheck
                      onChange={() => setIsEnabled(!isEnabled)}
                      id="websitepermissionenable"
                      name="custom_website_permissions_enabled"
                      checked={isEnabled}
                    />
                    <h5 className="mb-0 primary">Enable</h5>
                  </Row>
                  {customPermissions.map((item, idx) => {
                    let website = item.website;

                    return isEnabled ? (
                      <Row key={item.id} className="mb-3 align-items-center">
                        <Col xs={4} className="px-0 px-lg-3">
                          <Form.Group controlid="primarySite" className="mb-0">
                            <Form.Control
                              disabled={!isEnabled}
                              size="sm"
                              className="tableSearch mr-2 mb-0 col col-12"
                              placeholder=""
                              defaultValue={website}
                              required
                              name={`custom_website_permissions[][website]`}
                            />
                          </Form.Group>
                        </Col>
                        <Col className="px-0 px-lg-3 text-center">
                          <div>
                            <Form.Label>
                              {" "}
                              <h6 className="nunito-regular primary mb-0">Set to: </h6>{" "}
                            </Form.Label>
                            <input type="hidden" name="custom_website_permissions[][id]" value={item.id ? item.id : uuidv4()} />
                          </div>
                        </Col>
                        <Col className="px-0 px-lg-3">
                          <div>
                            <NumberDropdown item={idx + 1} webName={`custom_website_permissions[][permission]`} permission={parseInt(item.permission)} />
                          </div>
                        </Col>
                        <Col className="px-0 px-lg-3">
                            <i
                              className="ml-3 fas fa-minus-circle"
                              onClick={() => {
                                const newPermissions = customPermissions.filter((el) => item.id !== el.id);
                                setCustomPermissions([...newPermissions]);
                              }}>
                            </i>
                        </Col>
                      </Row>
                    ) : null;
                  })}
                  <Row className="mb-0 align-items-center ">
                    <Col className="pl-0">
                      <Button
                        className="mb-3 py-1 px-3 mx-3 btn-circle btn-sm text-center"
                        variant="success"
                        onClick={(e) => permissionHandler([...customPermissions, { id: uuidv4(), website: "", permission: 4 }])}>
                        + Add field
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </Row>

              <Row style={{ minHeight: "100px" }}></Row>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}
